const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0.0 0.0 222.8 222.0",
    zoomAndPan: "magnify",
    style: {
      fill: "rgb(0, 0, 0)"
    },
    original_string_length: 1085,
    width: "37.216004003188225px",
    height: "37.08067307954026px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "__id10_son29lvk7l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.83,111.42C222.83,49.88,172.95,0,111.42,0S0,49.88,0,111.42c0,52.25,35.97,96.1,84.5,108.14v-74.09h-22.98v-34.05h22.98v-14.67c0-37.92,17.16-55.5,54.39-55.5,7.06,0,19.24,1.38,24.22,2.77v30.86c-2.63-.28-7.2-.42-12.87-.42-18.27,0-25.33,6.92-25.33,24.91v12.04h36.39l-6.25,34.05h-30.14v76.55c55.17-6.66,97.92-53.64,97.92-110.6Z",
    style: {
      fill: "rgb(55, 55, 55)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.06,145.46l6.25-34.05h-36.39v-12.04c0-17.99,7.06-24.91,25.33-24.91,5.67,0,10.24.14,12.87.42v-30.86c-4.98-1.38-17.16-2.77-24.22-2.77-37.23,0-54.39,17.58-54.39,55.5v14.67h-22.98v34.05h22.98v74.09c8.62,2.14,17.63,3.28,26.92,3.28,4.57,0,9.07-.28,13.5-.82v-76.55h30.14Z",
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8fd4208e6e03c583907a15d969b77592.svg";
export { ForwardRef as ReactComponent };